import { render, staticRenderFns } from "./SalaEspera.vue?vue&type=template&id=44109ec7&scoped=true"
import script from "./SalaEspera.vue?vue&type=script&lang=js"
export * from "./SalaEspera.vue?vue&type=script&lang=js"
import style0 from "./SalaEspera.vue?vue&type=style&index=0&id=44109ec7&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44109ec7",
  null
  
)

export default component.exports